import { render, staticRenderFns } from "./TheSendOptions.vue?vue&type=template&id=6588ba39&scoped=true"
import script from "./TheSendOptions.vue?vue&type=script&lang=js"
export * from "./TheSendOptions.vue?vue&type=script&lang=js"
import style0 from "./TheSendOptions.vue?vue&type=style&index=0&id=6588ba39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6588ba39",
  null
  
)

export default component.exports